import CreateResourcePage from './CreateResourcePage';

export default CreateResourcePage;
